function usePos() {
    return window.shopify.pos;
}

export default usePos;
